import React from 'react';
import { mapPinType } from '../../constants';
import { Box } from 'pcln-design-system';
import { Pin as PinIcon, Beach as BeachIcon, Restaurant as RestaurantIcon, KingBed as HotelIcon, Museum as MuseumIcon, Departure as AirportIcon, Attraction as AttractionIcon, Train as TrainIcon, Mountain as MountainIcon, Park as ParkIcon, Activity as ActivityIcon } from 'pcln-icons';
import styled from 'styled-components';
const IconBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SinglePinIcon__IconBox",
  componentId: "sc-eocgev-0"
})(["border-radius:50%;box-shadow:0 -1px 0 0 rgba(0,0,0,0.03),0 0 2px 0 rgba(0,0,0,0.2),0 4px 2px -2px rgba(0,0,0,0.12),0 4px 8px -1px rgba(0,0,0,0.16);width:24px;height:24px;background:linear-gradient( 132.8deg,#7701bb 12.64%,#7601bb 17.94%,#7503bc 23.08%,#7205bd 28.07%,#6e09bf 32.93%,#690dc1 37.69%,#6312c4 42.36%,#5c18c7 46.96%,#541fca 51.52%,#4c27ce 56.05%,#422fd2 60.57%,#3738d7 65.11%,#2c42dc 69.68%,#204de1 74.31%,#1358e7 79.01%,#0564ed 83.8% ),radial-gradient( 90.13% 94.81% at 14.57% 5.35%,rgba(245,235,250,0.7) 0%,rgba(238,222,246,0.605208) 16.15%,rgba(232,210,243,0.514991) 33.33%,rgba(209,168,232,0.203394) 66.15%,rgba(201,153,228,0.0965608) 82.29%,rgba(194,140,224,0) 100% ),radial-gradient( 33.32% 66.63% at 81.46% 89.53%,rgba(232,242,255,0.3) 0%,rgba(232,242,255,0.3) 0.01%,rgba(153,195,249,0) 100% );svg{transform:translate(25%,24%);height:16px;width:16px;}"]);
export const MapIcon = ({
  type,
  iconProp
}) => {
  switch (type) {
    case mapPinType.MUSEUM:
      return React.createElement(MuseumIcon, Object.assign({}, iconProp));
    case mapPinType.BEACH:
      return React.createElement(BeachIcon, Object.assign({}, iconProp));
    case mapPinType.RESTAURANT:
      return React.createElement(RestaurantIcon, Object.assign({}, iconProp));
    case mapPinType.HOTEL:
      return React.createElement(HotelIcon, Object.assign({}, iconProp));
    case mapPinType.AIRPORT:
      return React.createElement(AirportIcon, Object.assign({}, iconProp));
    case mapPinType.MOUNTAIN:
      return React.createElement(MountainIcon, Object.assign({}, iconProp));
    case mapPinType.PARK:
      return React.createElement(ParkIcon, Object.assign({}, iconProp));
    case mapPinType.ACTIVITY:
      return React.createElement(ActivityIcon, Object.assign({}, iconProp));
    case mapPinType.ATTRACTION:
    case mapPinType.POI:
      return React.createElement(AttractionIcon, Object.assign({}, iconProp));
    case 'TRANSIT':
      return React.createElement(TrainIcon, Object.assign({}, iconProp));
    case 'CITY':
    default:
      return React.createElement(PinIcon, Object.assign({}, iconProp));
  }
};
export const SinglePinIcon = ({
  type
}) => {
  return React.createElement(IconBox, {
    bg: 'background.lightest'
  }, React.createElement(MapIcon, {
    type: type,
    iconProp: {
      color: 'text.lightest'
    }
  }));
};